<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5 class="vue-title">
          <strong>{{ $t("CHANGEPASSWORD1") }}</strong>
        </h5>
        <div><br/>
          <b-form class="formTextSize" @submit.prevent="submitForm">
            <b-row>
              <b-col sm="3">
                <b-form-group id="addressField" label-for="input-1">
                  <span>
                    {{ $t("NEWPASSWORD") }}
                  </span>
                   <span class="mandotry-color">*</span>
                  <b-form-input
                    v-model.trim="$v.passwordForm.password.$model"
                    class="inputField"
                    type="password"
                    autocomplete="name"
                    trim
                  ></b-form-input>
                  <show-errors
                    :control="$v.passwordForm.password"
                    :field="$t('MANDATORY')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group id="addressField" label-for="input-1">
                  <span>
                    {{ $t("CONFIRMNEWPASSWORD") }}
                  </span>
                   <span class="mandotry-color">*</span>
                  <b-form-input
                    v-model.trim="$v.passwordForm.confirm_password.$model"
                    class="inputField"
                    type="password"
                    autocomplete="name"
                    trim
                  ></b-form-input>
                  <show-errors
                    :control="$v.passwordForm.confirm_password"
                    :field="$t('MANDATORY')"
                  /> </b-form-group
              ></b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <b-button
                  class="btn btn-secondary formTextSizeBlack mr-2"
                  @click="gotoPreviousPage"
                  >{{ $t("CANCEL") }}</b-button
                >
                <button class="btn btn-primary formTextSizeBlack" type="submit">
                  {{ $t("CHANGE") }}
                </button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShowErrors from "@/components/ShowErrors";
import { required, helpers,sameAs } from "vuelidate/lib/validators";
import { CHANGE_PASSWORD } from "@/store/actions.type";
const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{10,}$/;
const specialPassword = helpers.regex("specialPassword", regex);
export default {
  name: "passwordchage",
   components: {
    ShowErrors
  },
  data() {
    return {
      passwordForm: {
        password: "",
        confirm_password: ""
      }
    };
  },
  validations: {
    passwordForm: {
      password: { required,
        specialPassword },
      confirm_password: { required, sameAsPassword: sameAs("password") }
    }
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.$v.passwordForm.$invalid) {
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        let payload = this.passwordForm;
        this.$store.dispatch(CHANGE_PASSWORD, payload).then(data => {
          this.isLoading.hide();
          if (data.status == true) {
            this.$toast.success({
              message: data.message
            });
            this.$router.go(-1)
          } else {
            this.$toast.error({
              message: data.message
            });
          }
        });
      }
    },
     gotoPreviousPage(){
      this.$router.go(-1)
    }
  }
};
</script>
